var inform = angular.module('inform', []);

